import { PluginKey } from 'prosemirror-state'

export const tableSelectionPluginKey = new PluginKey('selectingCells')
